export const weightManagementFeatureKey = 'weightManagement';
